/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LayoutState {
  fullScreenKey: string | null;
}

const initialState: LayoutState = {
  fullScreenKey: null,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    /**
     * Toggle fullscreen for specific table
     */
    toggleFullScreen(state, action: PayloadAction<string>) {
      state.fullScreenKey =
        state.fullScreenKey === action.payload ? null : action.payload;
    },

    /**
     * Exit fullscreen (optional)
     */
    exitFullScreen(state) {
      state.fullScreenKey = null;
    },
  },
});

export const {
  toggleFullScreen,
  exitFullScreen,
} = layoutSlice.actions;
export default layoutSlice.reducer;
